// extracted by mini-css-extract-plugin
export default {"flag":"CustomPageEditBasic_flag__SIwby"};